module.exports = __webpack_public_path__ + "9c036caf74082eb3addb5d45801f3b8f.png";